import React, {useState} from 'react';
import {Box} from '@mui/material';
import {Link} from 'react-router-dom';
import ArrCollapsiblePanel from '../../../components/common/arr-collapsible-panel/ArrCollapsiblePanel';

const CollapsiblePanelDemo: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <Box className="demo-page banner-demo">
      <Link to="/demo" className="link">
        Return back to demo
      </Link>

      <ArrCollapsiblePanel
        title="Filter Documents By"
        isExpanded={open}
        onToggle={(val) => setOpen(val)}
        content={<div>Filter options go here</div>}
        tooltipText="View for more information about panel."
        className="custom-panel"
      />
    </Box>
  );
};

export default CollapsiblePanelDemo;
